// Refusals of AI question generation
// (POST /assignments/{id}/questions/{serial}/generate). The body has the same
// shape as the document-review INSUFFICIENT_CREDITS refusal:
// { "code": "...", "message": "..." }.

// HTTP 429: a free account has used today's generations (paid plans are
// unlimited). `message` is the server's explanation, shown as is.
export const QUESTION_GENERATION_DAILY_LIMIT =
  'QUESTION_GENERATION_DAILY_LIMIT';

// HTTP 503: the kill switch is on.
export const QUESTION_GENERATION_DISABLED = 'QUESTION_GENERATION_DISABLED';

export const QUESTION_GENERATION_REFUSALS = [
  QUESTION_GENERATION_DAILY_LIMIT,
  QUESTION_GENERATION_DISABLED,
];

export const QUESTION_GENERATION_LIMIT_TITLE =
  'Daily AI question limit reached';
export const QUESTION_GENERATION_LIMIT_FALLBACK_MESSAGE =
  "You've used today's free AI question generations. You can still write the question yourself.";
export const QUESTION_GENERATION_UNAVAILABLE_MESSAGE =
  'AI question generation is unavailable right now. You can still write the question yourself.';
export const QUESTION_GENERATION_FAILED_MESSAGE =
  "We couldn't generate that right now. Please try again.";

// modifyData's stand-in when a failed response carries no message.
const isPlaceholderMessage = (message) =>
  !message || /^Error occurred: \d+$/.test(message);

const userMessage = ({ status, code, serverMessage }) => {
  if (code === QUESTION_GENERATION_DAILY_LIMIT) {
    return isPlaceholderMessage(serverMessage)
      ? QUESTION_GENERATION_LIMIT_FALLBACK_MESSAGE
      : serverMessage;
  }
  // Any 503 reads as "unavailable", including one from the platform in front of
  // the API, which carries no code.
  if (code === QUESTION_GENERATION_DISABLED || status === 503) {
    return QUESTION_GENERATION_UNAVAILABLE_MESSAGE;
  }
  return QUESTION_GENERATION_FAILED_MESSAGE;
};

/**
 * The error a failed generate call rejects with, built from postApi's
 * `includeMessages` envelope ({ data: null, status, errorCode, errorMessage }).
 * `message` is ready to show the user; `code` and `status` are the server's.
 */
export const questionGenerationError = (response) => {
  const status = response?.status ?? null;
  const code = response?.errorCode ?? null;
  return Object.assign(
    new Error(
      userMessage({ status, code, serverMessage: response?.errorMessage })
    ),
    { name: 'QuestionGenerationError', status, code }
  );
};

export const isQuestionGenerationDailyLimit = (error) =>
  error?.code === QUESTION_GENERATION_DAILY_LIMIT;
